import axios from "axios";
import Config from "../../..//../config";

const v2_actionInsightsExecutivo = querys => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/dashboard/relatorios/insights/executivo${querys}`
    });
};

export default v2_actionInsightsExecutivo;
